export default {
  labels: {
    order: 'Encomenda',
    customer: 'Cliente',
  },
  tags: {
    new_customer: 'Novo Cliente',
    loyal_customer: 'Cliente Fiel',
  },
};
